import {DG_axiosNormal} from "../../../../custom/axios/normal";
import {updateLocalAccessToken} from "../../../../custom/axios";

const BASE_URL_REFRESH_TOKEN = `/login-rest/v2.0/refreshtoken`;
const BASE_URL_LOG_OUT = `/login-rest/v2.0/logout`;

export const refreshAccessToken = async () => {
    return await refreshToken().then(r => {

        const {accessToken} = r.data

        updateLocalAccessToken(accessToken);
    });
};

export const refreshToken = () => {
    return DG_axiosNormal.post(
        BASE_URL_REFRESH_TOKEN,
        {},
        {
            withCredentials: true
        }
    );
};

export const logout = () => {
    return DG_axiosNormal.post(
        BASE_URL_LOG_OUT,
        {},
        {
            withCredentials: true
        }
    );
}